'use strict';
import angular from 'angular';
import './scripts/workflows.components';
import './scripts/workflows.ctrls';
import './scripts/workflows.directives';
import './scripts/workflows.filters';
import './scripts/workflows.services';

import workFlowsHtmlUrl from './views/workflows.html';
import workFlowActionsHtmlUrl from './views/workflowActions.html';
import workFlowViewHtmlUrl from './views/workflowView.html';
import workFlowTaskHtmlUrl from './views/workflowTask.html';
import wfFullViewHtmlUrl from './views/wfFullView.html';


angular.module('workflows', [
    'workflows.ctrls',
    'workflows.services',
    'workflows.directives',
    'workflows.filters',
    'workflows.components'
])

    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('workflows', {
                parent: 'layout',
                url: '/admin/workflows',
                templateUrl: workFlowsHtmlUrl,
                controller: 'WorkflowController'
            })
            .state('workflowActions', {
                parent: 'layout',
                url: '/admin/workflowActions',
                templateUrl: workFlowActionsHtmlUrl,
                controller: 'WorkflowActionController'
            })
            .state('workflowView', {
                parent: 'layout',
                url: '/admin/workflow/:id',
                templateUrl: workFlowViewHtmlUrl,
                controller: 'WorkflowViewController',
                params: {
                    workflow: null
                }
            })
            .state('workflowTask', {
                parent: 'layout',
                url: '/admin/workflowTasks/:id',
                templateUrl: workFlowTaskHtmlUrl,
                controller: 'WorkflowTaskController'
            })
            .state('wflowchart', {
                parent: 'layout',
                url: '/admin/wflowchart/:id',
                templateUrl: wfFullViewHtmlUrl,
                controller: 'WfFullViewController',
            })
        // .state('wfloweditor', {
        //     parent: 'layout',
        //     url: '/admin/wfloweditor',
        //     templateUrl: '/client/iotool/app/scripts/plugins/graph-editor/javascript/examples/editors/workfloweditor.html',
        //     controller: 'GraphController',
        // })
    }]);